<template>
    <v-empty-state headline="Oops, 404" title="Pagina no encontrada" text="La pagina que estas buscando no existe"
        image="https://supersistemasweb.com/acext/icons/attention.webp"></v-empty-state>
</template>
